import React, { useState, useEffect } from 'react';
import _get from 'lodash/get';
import { client } from 'cccisd-apollo';
import axios from 'cccisd-axios';
import { DeploymentPlayer, PrintMode } from 'cccisd-laravel-assignment';
import Loader from 'cccisd-loader';
import { useParams } from 'cccisd-react-router';
import query from './progress.graphql';
import { getSessionChecklistParentDeploymentId } from '../../helpers/helpers.js';

const Boilerplate = window.cccisd.boilerplate;

const TfhSessionChecklist = ({ isPrintMode }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [initialSessionNumber, setInitialSessionNumber] = useState(null);
    /* If all children are complete, this will be the parent ID to let te backend
        create the next Child. Otherwise, we force create a new Child. */
    const [deploymentId, setDeploymentId] = useState(null);
    const [metricspawn, setMetricspawn] = useState({});
    const params = useParams();

    useEffect(() => {
        async function getData() {
            const parentId = await getSessionChecklistParentDeploymentId();
            const resp = await client.query({
                query,
                variables: {
                    parentDeploymentId: parentId,
                    metricsPawnRespondentHash: params.shortHash,
                },
                fetchPolicy: 'network-only',
            });

            let maxSessionNum = 0;
            let isAllChildrenComplete = true;
            let deploymentIdGivenHash = null;
            (_get(resp, 'data.roles.metricspawn.assignmentProgressList', []) || []).forEach(ap => {
                if (params.deploymentHash && ap.deployment.hash === params.deploymentHash) {
                    deploymentIdGivenHash = ap.deployment.deploymentId;
                }

                if (!ap.completedDate) {
                    isAllChildrenComplete = false;
                }

                const currSessionNum = parseInt(ap?.devTags?.sessionChecklistSessionNumber, 10);
                if (!Number.isNaN(currSessionNum) && currSessionNum > maxSessionNum) {
                    maxSessionNum = currSessionNum;
                }
            });

            const pawn = _get(resp, 'data.roles.metricspawn.pawn', {}) || {};
            const group = _get(resp, 'data.roles.metricspawn.parentGroup.tfhClass.group', {}) || {};
            setMetricspawn({ ...pawn, ...group });

            if (!pawn.pawnId || !pawn.pawnHash) {
                // error will show in render
                setIsLoading(false);
                setDeploymentId(-1);
                return;
            }

            if (params.deploymentHash) {
                setDeploymentId(deploymentIdGivenHash);
            } else if (isAllChildrenComplete) {
                // backend will do it's thing to create next one
                setDeploymentId(parentId);
            } else {
                // We need to manually make sure it moves on to the next one
                const next = await axios.get(
                    Boilerplate.route('api.assignmentDeployment.repeated', {
                        deploymentId: parentId,
                        pawnId: pawn.pawnId,
                        hash: params.shortHash,
                    }),
                    { params: { forceRepeat: true } }
                );

                setDeploymentId(_get(next, 'data.data.deploymentId', -1));
            }

            setInitialSessionNumber(maxSessionNum + 1);
            setIsLoading(false);
        }

        getData();
    }, []);

    if (isLoading || !deploymentId) {
        return <Loader loading />;
    }

    if (!metricspawn.pawnId || !metricspawn.pawnHash) {
        return <div className="alert alert-warning">Incorrect link.</div>;
    }

    const linkToProgress = Boilerplate.url(`/dashboard?initialTab=progress&familyId=${metricspawn.groupId}`);
    const deploymentPlayerProps = {
        deploymentId,
        pawnId: metricspawn.pawnId,
        pawnHash: metricspawn.pawnHash,
        deploymentProps: {
            flowProps: {
                familyGroupId: metricspawn.groupId,
                familyGroupHash: metricspawn.randomHash,
                defaultValueVariables: {
                    sessionChecklistInitialSessionNumber: [initialSessionNumber],
                },
                variables: {
                    sessionChecklistLinkToProgress: `<a href="${linkToProgress}" target="_blank" style="text-decoration:underline;">Click to open Progress.</a>`,
                },
            },
        },
    };

    if (isPrintMode) {
        return (
            <div className="p-3">
                <PrintMode {...deploymentPlayerProps} />
            </div>
        );
    }

    return <DeploymentPlayer {...deploymentPlayerProps} flowProps={deploymentPlayerProps.deploymentProps.flowProps} />;
};

export default TfhSessionChecklist;
